<template>
	<transition name="el-fade-in-linear">
    <div v-show="transitionshow">      
	  
	</div>
	</transition>     
</template>

<script>
export default {
    data () {
        return {
        	actionauth:'', //功能权限
      	    transitionshow:true,
            url: this.GLOBAL.domain+"Order/index",
        }  
    },
  
    mounted(){
		//获取功能权限
		this.getactionauth();
		
    },
  
    methods:{
	    
	    //获取功能权限
		getactionauth() {
			var data =this.$cookies.get('actionauth');
		    data=JSON.parse(data);
		    this.actionauth=data;
		},
		  
    },
   
}
</script>


<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>



// WEBPACK FOOTER //
// src/components/mall/Orderedit.vue